// Define cell data type
const CELL_DATA_TYPES = {
  TEXT: 'text',
  EMAIL: 'email',
  NUMBER: 'number',
  DATE: 'date',
  DATETIME: 'datetime',
  TIMESTAMP: 'timestamp',
  DURATION: 'duration',
  STATUS: 'status',
  CONTACT_STATUS: 'contactStatus',
  MP3_STATUS: 'mp3Status',
  SWITCH: 'switch',
  PLATFORM: 'platform',
  MONEY: 'money',
  PERCENTAGE: 'percent',
  BOOL: 'boolean',
  CODE: 'code',
  PREVIEW: 'preview',
  IMAGE: 'image',
  SESSION_TYPE: 'sessionType',
  EMAIL_CAMPAIGN_STATUS: 'emailCampaignStatus',
  EMAIL_CAMPAIGN_RECIPIENTS_STATUS: 'emailCampaignRecipientsStatus',
  TABLE_LIST: 'table-list',
  ASSET_SUMMARY: 'assetSummary',
};

export default CELL_DATA_TYPES;
